<template>
  <base-dropdown :direction="footer ? 'up' : 'down'">
      <template #title-container><h4
        type="secondary"
        :style="{color: color.secondary}"
        class="dropdown-toggle mb-0"
      >{{group.translation.name}}</h4></template>
      
      <template v-for="item in group.items">
        <NavbarCustomOption v-if="item.type === 'option' && !!item.status" :footer="footer" :item="item" :key="item.id" :level="1"/>
        <NavbarCustomSubItems v-if="item.type === 'group' && !!item.status" :footer="footer" :subItem="item" :key="item.id"/>
      </template>
  </base-dropdown>
</template>

<script>
import BaseDropdown from "../../argon/components/BaseDropdown";
import NavbarCustomSubItems from "./NavbarCustomSubItems"
import NavbarCustomOption from "./NavbarCustomOption"
export default {
  name: "NavbarCustomGroup",
  components: {
    BaseDropdown,
    NavbarCustomSubItems,
    NavbarCustomOption
  },
  props: {
    group: Object,
    footer: Boolean,
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    }
  },
  computed: {
    color() {
      return this.$store.getters.NAV_COLOR;
    }
  }
};
</script>

<style scoped>
.nch--custom-menu {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  padding: 0 !important;
}
</style>
